export const Vendors = {
  AlbelliBe: "albelli.be",
  AlbelliDe: "albelli.de",
  AlbelliNl: "albelli.nl",
  BonusPrint: "bonusprint.co.uk",
  FotoKnudsen: "fotoknudsen.no",
  MonAlbumPhoto: "monalbumphoto.fr",
  Onskefoto: "onskefoto.se"
};

export const getVendor = url => {
  const split = url.split(".");
  const l = split.length;
  //if running at localhost we need a default
  if (l < 2) return Vendors.BonusPrint;

  //check the second level domain i.e. the xxx in website.xxx.zz, check its short enough to not be the vendor name...
  if (split[l - 2].length <= 3) return `${split[l - 3]}.${split[l - 2]}.${split[l - 1]}`;
  return `${split[l - 2]}.${split[l - 1]}`;
};

export const getCurrentVendor = () => getVendor(window.location.hostname);

export const mapToMerchandiseVendors = vendor => {
  // onskefoto.se is called albelli.se in Merchandise API
  return vendor === Vendors.Onskefoto ? "albelli.se" : vendor;
};

export const mapToRealVendors = vendor => {
  // onskefoto.se is called albelli.se in Merchandise API
  return vendor === "albelli.se" ? Vendors.Onskefoto : vendor;
};

export const getVendorName = () => {
  const entireVendor = getVendor(window.location.hostname);

  return entireVendor.split(".")[0];
};

export const vendor = getVendor(window.location.hostname);
